import { useQueryClient } from "@tanstack/react-query";
import { useListenNotificationStream } from "../../NotificationStream/hooks";
import { useInfiniteNotifications, useNotificationCount, } from "../../hooks";
import { PAGE_SIZE } from "../../hooks/constants";
import { NotificationFormats } from "../../types";
export const useListenNotificationStreamDocked = () => {
    const queryClient = useQueryClient();
    useListenNotificationStream((newNotification) => {
        if (newNotification.format !== NotificationFormats.DOCKED) {
            return;
        }
        queryClient.setQueriesData({
            queryKey: useInfiniteNotifications.keyWithoutOptions,
            predicate: (query) => {
                const [, , { format }] = query.queryKey;
                return (format == null ||
                    format === NotificationFormats.DOCKED ||
                    (typeof format === "object" &&
                        format.includes(NotificationFormats.DOCKED)));
            },
        }, (oldData) => {
            if (oldData == null) {
                return oldData;
            }
            const allNotifications = oldData.pages.flatMap((page) => page);
            allNotifications.unshift(newNotification);
            return Object.assign(Object.assign({}, oldData), { pages: allNotifications.reduce((acc, notification, i) => {
                    if (i % PAGE_SIZE === 0) {
                        acc.push([]);
                    }
                    acc[acc.length - 1].push(notification);
                    return acc;
                }, []) });
        });
        queryClient.setQueryData(useNotificationCount.generateKey(), (oldData) => (oldData !== null && oldData !== void 0 ? oldData : 0) + 1);
    });
};
//# sourceMappingURL=useListenNotificationStreamDocked.js.map